
// ==========================================
// 📝 BLOGS PAGE - src/pages/Blogs.js
// ==========================================

import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/ui/Button';
import { homepageAPI } from '../services/api';
import image1 from '../assets/images/blogs/image-1.jpg';
import image2 from '../assets/images/blogs/image-2.jpg';
import image3 from '../assets/images/blogs/image-3.jpg';
import image4 from '../assets/images/blogs/image-4.jpg';
import image5 from '../assets/images/blogs/image-5.jpg';
import image6 from '../assets/images/blogs/image-6.jpg';
import image7 from '../assets/images/blogs/image-7.jpg';
import image8 from '../assets/images/blogs/image-8.jpg';
import image9 from '../assets/images/blogs/image-9.jpg';
import image12 from'../assets/images/homepage/bottom.jpg';
import { Link } from 'react-router-dom';
// import image10 from '../assets/images/blogs/image-10.jpg';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `${API_BASE_URL}${imagePath}`;
};

const Blogs = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [blogs, setBlogs] = useState([]);
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fallback blog posts
  const fallbackBlogs = [
    { id: 1, category: 'Sustainability', time: '8 min read', title: 'Sustainable Baking Practices Every Modern Bakery Should Adopt', excerpt: 'Discover eco-friendly techniques...', date: 'Dec 15, 2024', author: 'Priya Sharma', image:image1 },
    { id: 2, category: 'Innovation', time: '15 min read', title: 'The Rise of Clean-Label Baking: How to Stay Ahead', excerpt: 'Consumer trends are shifting...', date: 'Dec 10, 2024', author: 'Rajesh Kumar', image:image2 },
    { id: 3, category: 'Production', time: '5 min read', title: '5 Ways to Improve Bread Quality Without Increasing Costs', excerpt: 'Practical tips for better products...', date: 'Dec 5, 2024', author: 'Amit Patel', image: image3 },
    { id: 4, category: 'Sustainability', time: '10 min read', title: 'From Recipe To Retail: Scaling Your Bakery With Consistency', excerpt: 'Learn the secrets of scaling...', date: 'Nov 28, 2024', author: 'Sneha Reddy', image: image4 },
    { id: 5, category: 'Innovation', time: '12 min read', title: 'Enzymes in Baking: The Science Behind Better Bread', excerpt: 'Understanding enzyme technology...', date: 'Nov 20, 2024', author: 'Dr. Vikram Singh', image:image5 },
    { id: 6, category: 'Production', time: '7 min read', title: 'Troubleshooting Common Baking Problems', excerpt: 'Solutions for everyday challenges...', date: 'Nov 15, 2024', author: 'Meera Joshi', image: image6 },
    { id: 7, category: 'Category', time: '7 min read', title: 'Blog title heading will go here', excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.', date: 'Nov 15, 2024', author: 'Meera Joshi', image: image7 },
    { id: 8, category: 'Category', time: '7 min read', title: 'Blog title heading will go here', excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.', date: 'Nov 15, 2024', author: 'Meera Joshi', image: image8 },
    { id: 9, category: 'Category', time: '7 min read', title: 'Blog title heading will go here', excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.', date: 'Nov 15, 2024', author: 'Meera Joshi', image: image9 },
    
  ];

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await homepageAPI.getBlogs();
        if (data && data.length > 0) {
          const processedBlogs = data.map(blog => ({
            ...blog,
            image: getFullImageUrl(blog.image)
          }));
          setBlogs(processedBlogs);
          setFeaturedBlogs(processedBlogs.filter(blog => blog.to_be_featured));
        } else {
          setBlogs(fallbackBlogs);
          setFeaturedBlogs(fallbackBlogs.slice(0, 3));
        }
        setLoading(false);
      } catch (err) {
        setBlogs(fallbackBlogs);
        setFeaturedBlogs(fallbackBlogs.slice(0, 3));
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const categories = ['All', 'Sustainability', 'Innovation', 'Production', 'Trends'];

  const filteredBlogs = blogs.filter(blog => {
    const matchesSearch = blog.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    blog.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || blog.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-white lg:bg-cream">
      <Header />

      {/* Hero */}
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto text-center max-w-7xl lg:px-8">
          <div className="mb-3 text-xs font-semibold tracking-wider uppercase text-primary">📚 Our Blog</div>
          <h1 className="mb-6 font-serif text-5xl font-bold text-text-primary">Fresh Ideas For Every Bake!</h1>
          <p className="max-w-3xl mx-auto mb-8 text-lg text-text-primary">
            Explore expert tips, industry trends, and innovative baking solutions from Enessa Foods—your trusted partner in baking success.
          </p>

          {/* Category Filters */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === cat 
                    ?  'text-white' 
                    : 'bg-white text-brown border-2 border-brown/20 hover:border-primary'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Search */}
          <div className="max-w-2xl mx-auto">
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-6 py-4 border-2 rounded-full border-brown/10 focus:border-primary focus:outline-none text-text-primary"
            />
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {loading ? (
              Array.from({ length: 6 }).map((_, idx) => (
                <div key={idx} className="animate-pulse">
                  <div className="h-56 mb-4 bg-gray-200 rounded-3xl"></div>
                  <div className="h-6 mb-2 bg-gray-200 rounded"></div>
                  <div className="h-16 bg-gray-200 rounded"></div>
                </div>
              ))
            ) : (
              filteredBlogs.map(blog => (
                <div key={blog.id} className="overflow-hidden transition-all bg-white rounded-3xl shadow-soft group hover:shadow-lg">
                  <div className="h-56 overflow-hidden bg-gray-200">
                    <img src={blog.image} alt={blog.title} className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">{blog.category}</span>
                      <span className="text-sm text-brown-light">• {blog.time}</span>
                    </div>
                    <h3 className="mb-3 text-xl font-bold transition-colors text-brown group-hover:text-primary line-clamp-2">{blog.title}</h3>
                    <p className="mb-4 text-sm text-brown-light line-clamp-2">{blog.excerpt}</p>
                    <div className="flex items-center justify-between">
                      <div className="text-xs text-text-primary">{new Date(blog.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                      <a href={`/blog/${blog.id}`} className="text-sm font-medium text-primary hover:underline">Read →</a>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {filteredBlogs.length === 0 && (
            <div className="py-12 text-center">
              <p className="text-lg text-text-primary">No articles found matching your search.</p>
            </div>
          )}
        </div>
      </section>

      {/* Featured Section */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">Insights That Rise Like Dough</h2>
            <p className="text-brown-light">Stay ahead with our expert articles on baking trends, innovations & industry tips.</p>
          </div>

          {/* Featured Posts */}
          {featuredBlogs.length > 0 ? (
            <div className="grid gap-4 lg:grid-cols-2">
              {/* Main Featured Post - Left Column */}
              <div className="overflow-hidden rounded-3xl">
                <img 
                  src={featuredBlogs[0]?.image || '/assets/images/blogs/featured.jpg'} 
                  alt={featuredBlogs[0]?.title} 
                  className="object-cover w-full h-80" 
                />
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">{featuredBlogs[0]?.category}</span>
                    <span className="text-sm text-text-primary">• {featuredBlogs[0]?.time || '20 min read'}</span>
                  </div>
                  <h3 className="mb-4 text-[32px] leading-[130%] capitalize" style={{fontFamily: 'Dream Orphanage', fontWeight: 400, color: '#561110'}}>
                    {featuredBlogs[0]?.title || '5 Ways To Improve Bread Quality Without Increasing Costs'}
                  </h3>
                  <p className="mb-4 leading-relaxed text-text-primary">
                    {featuredBlogs[0]?.excerpt || 'Discover proven techniques to enhance your bread quality while maintaining profitability.'}
                  </p>
                  {featuredBlogs[0]?.blog_content && (
                    <div className="mb-6 text-text-primary" dangerouslySetInnerHTML={{ __html: featuredBlogs[0].blog_content }} />
                  )}
                  <a 
                    href={`/blog/${featuredBlogs[0]?.id}`} 
                    className="inline-flex items-center gap-2 font-medium text-primary hover:underline"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>
              
              {/* Side Featured Posts - Right Column */}
              <div className="space-y-4">
                {featuredBlogs.slice(1, 4).map((blog, idx) => (
                  <div key={blog.id} className="flex gap-4 p-4 rounded-2xl">
                    <img 
                      src={blog.image} 
                      alt={blog.title} 
                      className="flex-shrink-0 object-cover w-40 h-40 rounded-lg" 
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">{blog.category}</span>
                        <span className="text-sm text-text-primary">• {blog.time}</span>
                      </div>
                      <h4 className="mb-2 text-[32px] leading-[130%] capitalize line-clamp-2" style={{fontFamily: 'Dream Orphanage', fontWeight: 400, color: '#561110'}}>
                        {blog.title}
                      </h4>
                      <a 
                        href={`/blog/${blog.id}`} 
                        className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline"
                      >
                        Read More
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-8 p-8 bg-white lg:bg-cream rounded-3xl lg:p-12 lg:flex-row">
              <div className="flex-1">
                <img src="{/assets/images/blogs/featured.jpg}" alt="Featured" className="object-cover w-full shadow-lg h-80 rounded-2xl" />
              </div>
              <div className="flex flex-col justify-center flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-start px-2 py-1 text-sm font-medium bg-white rounded-lg text-text-primary">Featured</span>
                  <span className="text-sm text-text-primary">• 20 min read</span>
                </div>
                <h3 className="mb-4 text-3xl font-bold text-text-primary">5 Ways To Improve Bread Quality Without Increasing Costs</h3>
                <p className="mb-6 leading-relaxed text-text-primary">Discover proven techniques to enhance your bread quality while maintaining profitability. From ingredient optimization to process improvements, we cover everything you need to know.</p>
                <a href="/blogs" className="inline-flex items-center gap-2 px-6 py-3 text-white transition-all rounded-full bg-primary hover:bg-primary/90">
                  Read More
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          )}
        </div>
      </section>

   {/* Final CTA with Chef */}
      <section className="py-24 bg-white lg:py-40 lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="bg-white rounded-[40px] p-12 lg:p-24 shadow-soft flex flex-col lg:flex-row-reverse items-center gap-16">
            <div className="flex-1">
              <img src={image12} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="mb-8 leading-tight font-heading text-heading-lg text-text-primary">
                Bookmark our blog & come back <br className="hidden lg:block" /> often for new posts.
              </h2>
              <p className="mb-10 leading-normal font-body text-body-lg text-text-primary">
                Stay inspired—bookmark our blog or subscribe to our newsletter for the latest baking tips, trends, and Enessa Foods updates.
              </p>
              <div className="flex flex-wrap justify-center gap-6 lg:justify-start">
                <Link to="/contact"><Button variant="primary" size="large">Contact Us</Button></Link>
                <Link to="/contact#inquiry-section"><Button variant="secondary" size="large">Enquiry Form</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};




export default Blogs;
